import { IPublicTenantLead } from "../Models";
import { baseUrl, getTokenFromLocalStorage } from "./Configuration";

export async function fetchPublicTenantLeads(): Promise<IPublicTenantLead[]> {
  try {
    const url = baseUrl + "/api/public/tenant-leads";
    console.log("🔵 API CALL: fetchPublicTenantLeads");
    console.log(`  URL: ${url}`);

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
      },
    });

    console.log(`  HTTP Status: ${response.status}`);

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return [];
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log(`  Response data:`, data);
    console.log(`  Items count: ${Array.isArray(data) ? data.length : 0}`);

    return data;
  } catch (error) {
    console.error("❌ Error in fetchPublicTenantLeads:", error);
    throw error;
  }
}
